// extracted by mini-css-extract-plugin
module.exports = {"Alert":"Alert_Alert__1V3nn","info_section":"Alert_info_section__z8W-3","title":"Alert_title__hzZY2 index_body__1cmOq"};